import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { SessaoService } from '../services/sessao.service';
import { RestClientService } from '../services/restclient.service';
import { MensagemService } from '../services/mensagem.service';
import { LiquidacaoAntecipadaService } from '../services/liquidacaoantecipada.service';
import { Contrato } from '../modelo/contrato';
import { Boleto } from '../modelo/boleto';
import { Config } from '../services/config';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var $: any;

@Component({
  selector: 'app-liquidacao-modal-confirmar',
  templateUrl: './liquidacao-modal-confirmar.component.html',
  styleUrls: ['./liquidacao.component.css'],
  providers: [LiquidacaoAntecipadaService, MensagemService, RestClientService]
})
export class LiquidacaoModalConfirmarComponent extends AbstractComponent implements OnInit {

  contrato: Contrato = new Contrato();
  boleto: Boleto = new Boleto();

  constructor(
    private sessaoService: SessaoService,
    private liquidacaoAntecipadaService: LiquidacaoAntecipadaService,
    private mensagemService: MensagemService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<LiquidacaoModalConfirmarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  ngOnInit() {
    this.contrato = this.data.contrato;
  }

  fechar() {
    this.dialogRef.close();
  }

  exibeParcelas() {
    $('.collapsible-body').slideToggle("slow");
    $('.icoshow').toggle();
  }

  onClickConfirmar(): void {
    this.fechar();
    this.liquidacaoAntecipadaService.efetivarLiquidacaoParcela(this.contrato).subscribe(
      (result: Boleto) => {
        if (result.cdMsgemRetorno == "0") {
          this.boleto = result;
          sessionStorage.setItem('liquidacaoBoleto', JSON.stringify(this.boleto));
          this.router.navigate(['/BF-Portal/liquidacaoParcelasConclusao']);
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-liquidacao-cli/liquidacao-modal-confirmar.component.ts